import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import editFill from "@iconify/icons-eva/edit-2-fill";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import moment from "moment";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Card, Table, Stack, Avatar, Button, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Switch } from "@mui/material";
import Page from "../../components/Page";
import Label from "../../components/Label";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import axios from "axios";
import MoreMenu from "src/components/common/MoreMenu";
import MyPagination from "src/components/common/MyPagination";
import ListHead from "src/components/common/ListHead";
import { BASE_URL, IMG_BASE_URL } from "src/config/constants";
import Confirm from "src/components/common/ConfirmDialog";
import ListToolbar from "src/components/common/ListToolbar";
import { asyncRequest } from "src/services/network";
import { alert } from "src/services/alert";
// ----------------------------------------------------------------------

const TABLE_HEAD = [{ id: "id", label: "ID", alignRight: false }, { id: "title", label: "标题", alignRight: false }, { id: "cover", label: "封面", alignRight: false }, { id: "isShow", label: "是否显示", alignRight: false }, { id: "created", label: "发布时间", alignRight: false }, { id: "" }];

const moreMenus = [
  { title: "编辑", icon: editFill },
  { title: "删除", icon: iconDelete },
];

export default function ArticleList() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState([]);

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    search: "",
  });

  useEffect(() => {
    getItems();
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/article/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }
  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
    });
  }
  function handleReset() {
    setFilter({
      page: 0,
      size: 10,
      search: "",
      uid: "",
      nickname: "",
      mobile: "",
    });
  }
  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      navigate(`/businessSchool/edit/${row.id}`, { state: row });
    } else if (type === "删除") {
      handleDelItem(row);
    }
  };

  function handleDelItem({ id }) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      async onConfirm() {
        const { msg } = await asyncRequest({
          path: "/article/del",
          data: { id },
        });

        setItems(items.filter((b) => b.id !== id));
        alert(msg, 'success');
      },
    });
  }

  const isUserNotFound = items.length === 0;

  return (
    <Page title="商学院列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            商学院列表
          </Typography>

          <Button variant="contained" component={RouterLink} to="/businessSchool/add" startIcon={<Icon icon={plusFill} />}>
            添加文章
          </Button>
        </Stack>

        <Card>
          <ListToolbar numSelected={selected.length} filterName={filter.search}  onReset={handleReset} onFilterName={(e) => handleFilterChange("search", e.target.value)} onRefresh={getItems} />
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                <TableBody>
                  {items.map((row) => {
                    const { id, title, isShow, cover, createdAt } = row;
                    const isItemSelected = selected.indexOf(title) !== -1;

                    return (
                      <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={isItemSelected} aria-checked={isItemSelected}>
                        <TableCell align="left">{id}</TableCell>
                        <TableCell align="left">{title}</TableCell>
                        <TableCell align="left">{!!cover && <img src={`${IMG_BASE_URL}${cover}`} style={{ maxWidth: 60 }} />}</TableCell>
                        <TableCell align="left">
                          {/* <Label
                              variant="ghost"
                              color={getStatusColor(isShow)}
                            >
                              {getStatusText(isShow)}
                            </Label> */}

                          <Switch checked={isShow} />
                        </TableCell>
                        <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>

                        <TableCell align="right">
                          <MoreMenu menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filter.search} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>
    </Page>
  );
}
